import React from 'react';
import { TRUST_ITEMS } from '../data/site';
import { Icon } from '../utils/icons';
import { Reveal } from './Reveal';
export function TrustBar() {
  return <section className="relative bg-white" aria-label="Nuestros pilares" data-id="element-253" data-mp="1c28ilk1igtbb">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 -mt-16 lg:-mt-20 relative z-10" data-id="element-254" data-mp="yaaejnmnpnm0">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-255" data-mp="138lp60ks025a">
          {TRUST_ITEMS.map((item, i) => <Reveal key={item.title} delay={i * 0.08} data-id="element-256" data-mp="1qxwiwy3pkw9x" data-mpi={i}>
              <article className="group h-full rounded-3xl border border-black/5 bg-white p-7 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-float" data-id="element-257" data-mp="1uzi2f2ar08t3">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-light text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-white" data-id="element-258" data-mp="1h1l6m844c6fh">
                  <Icon name={item.icon} className="h-6 w-6" data-id="element-259" data-mp="5mei8k101xpr" />
                </span>
                <h3 className="mt-5 text-base font-semibold leading-snug text-ink" data-id="element-260" data-mp="ah21o4h5c1xh">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-soft" data-id="element-261" data-mp="1akzwbyi7ufv0">{item.text}</p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}